require('./media.min.js');
/**
 * @param {string} webpSrc  图片的url
 * @returns {string} (webpSrc | src) 返回转换后的url
 * @description 用于美团、点评、猫眼容器下的webview页面是否支持webp格式的图片，不支持为m站webp解析
 * @author hejialiang
 * isWebpSupported、getKNBMedia由https://static.meituan.net/bs/knb-toolkit/master/media.min.js提供
 */
export function webpReplaceProtocol(webpSrc) {
  var _KNBMedia = KNBMedia,
    isWebpSupported = _KNBMedia.isWebpSupported,
    getKNBMedia = _KNBMedia.getKNBMedia;
  return isWebpSupported.then(function (isSupported) {
    if (isSupported === 1 || isSupported === 2) {
      // 支持 1.需要容器支持显示webp 2.支持webp不需要转换
      var src = isSupported === 2 ? webpSrc : getKNBMedia(webpSrc);
      return src;
    } else {
      // 不支持 
      return webpSrc;
    }
  }).catch(function (err) {
    console.warn(err);
  });
}